function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.75 12.25c-.32 0-.596-.114-.824-.343a1.121 1.121 0 01-.343-.824V8.167c0-.321.115-.596.343-.825C1.155 7.114 1.43 7 1.75 7V4.506a1.282 1.282 0 01-.423-.415 1.086 1.086 0 01-.16-.591v-.583c0-.321.114-.596.343-.825.228-.228.503-.342.823-.342H5.25c.32 0 .596.114.824.343.229.229.343.503.343.824V3.5c0 .224-.054.42-.16.59-.108.17-.249.31-.424.417V7h2.334V4.506a1.282 1.282 0 01-.423-.415 1.086 1.086 0 01-.16-.591v-.583c0-.321.114-.596.342-.825.229-.228.504-.342.824-.342h2.917c.32 0 .595.114.824.343.229.229.343.503.342.824V3.5c0 .224-.053.42-.16.59-.107.17-.248.31-.423.417V7c.32 0 .596.114.824.343.229.229.343.503.343.824v2.916c0 .321-.115.596-.343.825a1.121 1.121 0 01-.824.342H1.75zM9.333 7h1.75V4.667h-1.75V7zM2.917 7h1.75V4.667h-1.75V7z",
  fill: "currentColor"
});

var SvgLabStorage = function SvgLabStorage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgLabStorage;